interface Data {
	[key: string]: any;
}

export const flattenData = <T extends Data>(
	data: T[],
	childProperty: string
): T[] => {
	const flattenedData: T[] = [];

	function flatten(item: T) {
		flattenedData.push(item);
		if (item[childProperty].length) {
			item[childProperty].forEach((child: T) => flatten(child));
		}
	}
	data.forEach(item => flatten(item));
	return flattenedData;
};
